import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const [ active, setActive ] = useState(true)
    const [ searchFacet, setSearchFacet ] = useState("");
    const [ expanded, setExpanded ] = useState(false)
    const facetData = facet?.data;

    const handleChange = (e) => {
        setSearchFacet(e.target.value)
    }


    let filteredFacets = facetData.filter((facets) => {
        if (searchFacet === "") {
            return facetData
        } else {
            if (facets.value.toLowerCase().includes(searchFacet.toLowerCase())) {
                return facets
            }
        }
    })

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
            <span
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={() => setActive(!active)}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <span class="ns-facet-name">{facet.name}</span>
                {/* <Icon name="arrow" className="ns-absolute" /> */}
            </span>
            <div class="ns-sidebar-submenu ns-d-none" id={`${facet.id}-sub-menu`}>
                {facetData?.length > 10 &&
                    <div class="ns-input-facet-container ns-d-flex">
                        <input type="text"
                            placeholder={`Search ${facet.name}`}
                            class="ns-input-search"
                            onInput={handleChange} 
                        />
                        <svg class="icon-search" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none"> 
                            <title>Search icon</title> 
                            <path d="M19.5 21.5L13.6155 15.1628" stroke="currentColor" stroke-width="1.75"></path> <circle cx="9.5" cy="9.5" r="7" stroke="currentColor" stroke-width="1.75"></circle> 
                        </svg>
                    </div>
                }
                <ul class="ns-list-unstyled ns-m-0" role="menu">
                    {filteredFacets?.map( (value,index) => {
                        return (
                            <>
                                <li
                                    key={value.value}
                                    class={`ns-facet-value ${(index > 10 && !expanded) ? 'ns-facet-button' : ''}`}
                                    data-nosto-element="facet-setting"
                                    role="menuitem"
                                >
                                    <Checkbox
                                        value={value.value}
                                        selected={value.selected}
                                        onChange={e => {
                                            e.preventDefault()
                                            toggleProductFilter(facet.field, value.value, !value.selected)
                                        }}
                                    />
                                    <span class="ns-count ns-d-inline-block">
                                        ({value.count})
                                    </span>
                                </li>
                            </>
                        )
                    })}
                    {facetData?.length > 10 &&
                        <div class="ns-view-more" onClick={() => setExpanded(!expanded)}>
                            {expanded ? "See Less" : "See More"}
                        </div>
                    }
                </ul>
            </div>
        </li>
    )
}
